/* eslint-disable camelcase */
import superagentPromise from "superagent-promise";
import _superagent from "superagent";
import { configureStore } from "../store";
import { USER_LOGOUT } from "../auth/login/actionTypes";



const superagent = superagentPromise(_superagent, Promise);

const handleErrors = async (err) => {
  if (err && err.status === 401) {
    const store = configureStore();
    await store.dispatch({ type: USER_LOGOUT });
    localStorage.setItem('reduxState', undefined);
  }
};

const responseBody = (res) => res.body;
// const apiUrl = "https://api.ecswitchserver.com";
const apiUrl = window.__ENV && window.__ENV.apiUrl;
const requests = {
  post: (url, body) =>
    superagent
      .post(url, body)
      .set("Content-Type", "application/json")
      .on("error", handleErrors)
      .then(responseBody),
  postData: (url, body) =>
    superagent
      .post(url, body)
      .set("Content-Type", "application/x-www-form-urlencoded")
      .then(responseBody),
  getWithToken: (url, token) =>
    superagent
      .get(url)
      .set("Content-Type", "application/json")
      .set("Authorization", `Bearer ${token}`)
      .on("error", handleErrors)
      .then(responseBody),
  postWithToken: (url, body, token) =>
    superagent
      .post(url, body)
      .set("Content-Type", "application/json")
      .on("error", handleErrors)
      .set("Authorization", `Bearer ${token}`)
      .then(responseBody),
  deleteWithToken: (url, token) =>
    superagent
      .del(url, token)
      .set("Content-Type", "application/json")
      .on("error", handleErrors)
      .set("Authorization", `Bearer ${token}`)
      .then(responseBody),
  deleteWithTokenAndBody: (url, body, token) =>
    superagent
      .del(url, token)
      .send(body)
      .set("Content-Type", "application/json")
      .on("error", handleErrors)
      .set("Authorization", `Bearer ${token}`)
      .then(responseBody),
  putWithToken: (url, body, token) =>
    superagent
      .put(url, body, token)
      .set("Content-Type", "application/json")
      .on("error", handleErrors)
      .set("Authorization", `Bearer ${token}`)
      .then(responseBody),
};

const Auth = {
  login: (email, password) => {
    /* eslint-disable prefer-template */
    const formData =
      "username=" +
      encodeURIComponent(email) +
      "&password=" +
      encodeURIComponent(password) +
      "&grant_type=password";
    return requests.postData(`${apiUrl}/token`, formData);
  },
  getCurrentUser: (access_token) => {
    return requests.getWithToken(`${apiUrl}/api/user/profile`, access_token);
  },
  enableAccount: (data, code) => {
    const { password, confirmPassword } = data;
    return requests.postData(`${apiUrl}/api/user/enableuser`, { password, confirmPassword, code, });
  },

  forgotPassword: (email) => {
    return requests.postData(`${apiUrl}/api/user/forgotpassword`, { email });
  },
  resetPassword: (data, code) => {
    const { password, confirmPassword, email } = data;
    return requests.postData(`${apiUrl}/api/user/resetpassword`, { password, confirmPassword, code, email, });
  },
};

const Dashboard = {
  getDashboardData: (accessToken) => {
    return requests.getWithToken(`${apiUrl}/api/dashboard`, accessToken);
  }
}

const User = {
  createUser: (access_token, user) => {
    const {
      firstName,
      lastName,
      displayName,
      email,
      mobileNumber,
      new_user_organisation,
      new_retailer,
      new_user_role,
      isNotify,
      addressLine1,
      addressLine2,
      selected_zone,
      selected_state,
      town,
      zip,
      district,
      RolePermissions
    } = user;
    return requests.postWithToken(`${apiUrl}/api/user/create`,
      {
        firstName,
        lastName,
        displayName,
        email,
        mobileNumber,
        NotifyUser: isNotify,
        roleName: new_user_role && new_user_role.value,
        orgId: new_user_organisation,
        retailerId: (new_retailer && new_retailer.value) || null,
        addressLine1,
        addressLine2,
        zone: selected_zone,
        town,
        state: selected_state,
        zip,
        district,
        RolePermissions,
      },
      access_token
    );
  },
  getUsers: (access_token, currentPage = 1, pageSize = 10, searchDisplayName, searchRoleDisplayName, searchOrgName, searchEmail, searchMobileNumber, searchCreatedBy, searchCreatedByEmail, searchAvailableDevices, searchIsActive, searchIsEnabled, searchCreatedDateTime, sortDirection, sortOrder) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/userlist?$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += `&$orderby=createdDateTime desc`;
    }
    if (searchDisplayName || searchRoleDisplayName || searchOrgName || searchEmail || searchMobileNumber || searchCreatedBy || searchCreatedByEmail || searchAvailableDevices || searchIsActive || searchIsEnabled || searchCreatedDateTime) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchDisplayName) {
        if (searchDisplayName.toLowerCase() === 'na') {
          filterArray.push('displayName eq null');
        } else {
          filterArray.push(`contains(tolower(displayName),tolower('${searchDisplayName}'))`);
        }
      }
      if (searchRoleDisplayName) {
        if (searchRoleDisplayName.toLowerCase() === 'na') {
          filterArray.push('roleKey eq null');
        } else {
          filterArray.push(`roleKey eq '${encodeURIComponent(searchRoleDisplayName)}'`);
        }
      }
      if (searchOrgName) {
        if (searchOrgName.toLowerCase() === 'na') {
          filterArray.push('orgName eq null');
        } else {
          filterArray.push(`contains(tolower(orgName),tolower('${encodeURIComponent(searchOrgName)}'))`);
        }
      }
      if (searchEmail) {
        if (searchEmail.toLowerCase() === 'na') {
          filterArray.push('((email eq null) or (displayName eq null) or (displayName eq \'\'))');
        } else {
          filterArray.push(`(contains(tolower(email),tolower('${encodeURIComponent(searchEmail)}')) or contains(tolower(displayName),tolower('${encodeURIComponent(searchEmail)}')))`);
        }
      }
      if (searchMobileNumber) {
        if (searchMobileNumber.toLowerCase() === 'na') {
          filterArray.push('mobileNumber eq null');
        } else {
          filterArray.push(`contains(tolower(mobileNumber),tolower('${encodeURIComponent(searchMobileNumber)}'))`);
        }
      }
      if (searchCreatedBy) {
        if (searchCreatedBy.toLowerCase() === 'na') {
          filterArray.push('createdBy eq null');
        } else {
          filterArray.push(`contains(tolower(createdBy),tolower('${encodeURIComponent(searchCreatedBy)}'))`);
        }
      }
      if (searchCreatedByEmail) {
        if (searchCreatedByEmail.toLowerCase() === 'na') {
          filterArray.push('((createdByEmail eq null) or (createdBy eq null))');
        } else {
          filterArray.push(`(contains(tolower(createdByEmail),tolower('${encodeURIComponent(searchCreatedByEmail)}')) or contains(tolower(createdBy),tolower('${encodeURIComponent(searchCreatedByEmail)}')))`);
        }
      }
      if (searchAvailableDevices) {
        if (searchAvailableDevices.toLowerCase() === 'na') {
          filterArray.push('availableDevices eq null');
        } else {
          filterArray.push(`availableDevices eq ${encodeURIComponent(searchAvailableDevices)}`);
        }
      }
      if (searchIsActive) {
        if (searchIsActive.toLowerCase() === 'all') {
          filterArray.push('((isActive eq true) or (isActive eq false))');
        } else {
          filterArray.push(`isActive eq ${encodeURIComponent(searchIsActive)}`);
        }
      }
      if (searchIsEnabled) {
        if (searchIsEnabled.toLowerCase() === 'all') {
          filterArray.push('((isEnabled eq true) or (isEnabled eq false))');
        } else {
          filterArray.push(`isEnabled eq ${encodeURIComponent(searchIsEnabled)}`);
        }
      }
      if (searchCreatedDateTime) {
        if (searchCreatedDateTime.toLowerCase() === 'na') {
          filterArray.push('createdDateTime eq null');
        } else {
          filterArray.push(`createdDateTime eq ${encodeURIComponent(searchCreatedDateTime)}`);
        }
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }
    // if (searchRoleDisplayName) {
    //   url += `&roleKey=${searchRoleDisplayName}`;
    //   // filterArray.push(`roles/roleDisplayName eq '${searchRoleDisplayName}'`);
    // }
    return requests.getWithToken(url, access_token);
  },
  exportData: (access_token) => {
    return requests.getWithToken(`${apiUrl}/odata/userlist/export?$count=true&$orderby=createdDateTime desc`, access_token);
  },

  getUserDetails: (access_token, userId) => {
    return requests.getWithToken(`${apiUrl}/api/user/details?userId=${userId}`, access_token);
  },
  getOrgPreference: (access_token) => {
    return requests.getWithToken(`${apiUrl}/api/org/orgpreferencedetails`, access_token);
  },
  getFilteredStates: (access_token, searchValue) => {
    const _ = require('lodash');
    const data = _.upperFirst(searchValue)
    return requests.getWithToken(`${apiUrl}/api/states?key=${data}`, access_token);
  },
  getAssignableRetailers: (access_token, organisationId) => {
    return requests.getWithToken(`${apiUrl}/api/user/assignable/retailers?organisationId=${organisationId}`, access_token);
  },
  updateUser: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/user/update`, data, access_token);
  },
  updateOrgPreference: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/org/orgpreferenceupdate`, data, access_token);
  },
  sendResetPasswordEmail: (email) => {
    return requests.post(`${apiUrl}/api/user/reactivate`, { email });
  },
  changePassword: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/user/changepassword`, data, access_token);
  },
  directChangePassword: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/user/resetpassworddirect`, data, access_token);
  },
  deleteSelfAccount: (access_token) => {
    return requests.deleteWithToken(`${apiUrl}/api/user/delete/self/account`, access_token);
  },
  deleteOthersAccount: (access_token, selectedUserId) => {
    return requests.deleteWithToken(`${apiUrl}/api/user/delete?deletedUserId=${selectedUserId}`, access_token);
  },
  getAssignableUsers: (access_token, searchValue, organisationId) => {
    return requests.getWithToken(`${apiUrl}/api/user/assignable?organisationId=${organisationId}&key=${searchValue}`, access_token);
  },
  getAssignableTransferUser: (access_token, userId, organisationId) => {
    return requests.getWithToken(`${apiUrl}/api/user/assignable/${userId}/${organisationId}`, access_token);
  },
  getSubordinates: (access_token, organisationId, userId) => {
    return requests.getWithToken(`${apiUrl}/api/user/subordinates/${userId}/${organisationId}`, access_token);
  },
  transferUsers: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/user/transfer`, data, access_token);
  },
  getOrganisations: (access_token, mfgFilter, searchValue) => {
    let url = `${apiUrl}/odata/orglist?$orderby=createdDateTime desc`;
    if (searchValue || mfgFilter) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchValue) {
        filterArray.push(`contains(tolower(name), tolower('${searchValue}'))`)
      }
      if (mfgFilter) {
        if (mfgFilter === "manufacturer") {
          filterArray.push(`contains(orgType, 'manufacturer')`)
        }
        else {
          filterArray.push(`orgType ne 'manufacturer'`)
        }
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }

    return requests.getWithToken(url, access_token)
  },
}

const Organisation = {
  createOrganisation: (access_token, organisation) => {
    const {
      name,
      orgType,
      pincode,
      addressLine1,
      addressLine2,
      city,
      country,
      state,
      applicationName,
      applicationLogo,
      approveNewCustomer,
      allowCustomerSelfRegistration,
      enableUserMailNotification,
      isReturnApproval,
      isEnableApiAccess,
      isEnableOnlySwitchMobileApp
    } = organisation;
    return requests.postWithToken(`${apiUrl}/api/org/create`,
      {
        OrgName: name,
        orgType,
        pincode,
        addressLine1,
        addressLine2,
        city,
        country,
        state,
        applicationName,
        applicationLogo,
        approveNewCustomer,
        allowCustomerSelfRegistration,
        enableUserMailNotification,
        isReturnApproval,
        isEnableApiAccess,
        isEnableOnlySwitchMobileApp
      },
      access_token
    );
  },
  getOrganisations: (access_token, currentPage = 1, pageSize = 10, searchName, searchOrgType, searchUserCount, searchDeviceCount, searchAddress, searchActive, searchApproveNewCustomer, searchAllowCustomerSelfRegistration, searchEnableUserMailNotification, searchCreatedDateTime, sortDirection, sortOrder) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/orglist?$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += `&$orderby=createdDateTime desc`;

    }
    if (searchName || searchOrgType || searchUserCount || searchDeviceCount || searchAddress || searchActive || searchApproveNewCustomer || searchAllowCustomerSelfRegistration || searchEnableUserMailNotification || searchCreatedDateTime) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchName) {
        if (searchName.toLowerCase() === 'na') {
          filterArray.push('name eq null');
        } else {
          filterArray.push(`contains(tolower(name),tolower('${encodeURIComponent(searchName)}'))`);
        }
      }
      if (searchOrgType) {
        if (searchOrgType.toLowerCase() === 'na') {
          filterArray.push('orgType eq null');
        } else {
          filterArray.push(`contains(tolower(orgType),tolower('${encodeURIComponent(searchOrgType)}'))`);
        }
      }
      if (searchUserCount) {
        if (searchUserCount.toLowerCase() === 'na') {
          filterArray.push('userCount eq null');
        } else {
          filterArray.push(`userCount eq ${encodeURIComponent(searchUserCount)}`);
        }
      }
      if (searchDeviceCount) {
        if (searchDeviceCount.toLowerCase() === 'na') {
          filterArray.push('deviceCount eq null');
        } else {
          filterArray.push(`deviceCount eq ${encodeURIComponent(searchDeviceCount)}`);
        }
      }
      if (searchAddress) {
        if (searchAddress.toLowerCase() === 'na') {
          filterArray.push('address eq null');
        } else {
          filterArray.push(`contains(tolower(address),tolower('${encodeURIComponent(searchAddress)}'))`);
        }
      }
      if (searchActive) {
        if (searchActive.toLowerCase() === 'na') {
          filterArray.push('active eq null');
        } else {
          filterArray.push(`active eq ${encodeURIComponent(searchActive)}`);
        }
      }
      if (searchApproveNewCustomer) {
        if (searchApproveNewCustomer.toLowerCase() === "false") {
          filterArray.push('((approveNewCustomer eq null)or (approveNewCustomer eq false))');
        } else {
          filterArray.push(`approveNewCustomer eq ${encodeURIComponent(searchApproveNewCustomer)}`);
        }
      }
      if (searchAllowCustomerSelfRegistration) {
        if (searchAllowCustomerSelfRegistration.toLowerCase() === "false") {
          filterArray.push('((allowCustomerSelfRegistration eq null) or (allowCustomerSelfRegistration eq false))');
        } else {
          filterArray.push(`allowCustomerSelfRegistration eq ${encodeURIComponent(searchAllowCustomerSelfRegistration)}`);
        }
      }
      if (searchEnableUserMailNotification) {
        if (searchEnableUserMailNotification.toLowerCase() === "false") {
          filterArray.push('((enableUserMailNotification eq null) or (enableUserMailNotification eq false))');
        } else {
          filterArray.push(`enableUserMailNotification eq ${encodeURIComponent(searchEnableUserMailNotification)}`);
        }
      }
      if (searchCreatedDateTime) {
        if (searchCreatedDateTime.toLowerCase() === "na") {
          filterArray.push('createdDateTime eq null');
        } else {
          filterArray.push(`createdDateTime eq ${encodeURIComponent(searchCreatedDateTime)}`);
        }
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }
    return requests.getWithToken(url, access_token);
  },
  getOrganisationDetails: (access_token, organisationId) => {
    return requests.getWithToken(`${apiUrl}/api/org/details?orgId=${organisationId}`, access_token);
  },
  updateOrganisation: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/org/update`, data, access_token);
  },
};

const Request = {
  getRequests: (access_token, currentPage = 1, pageSize = 10, sortDirection, sortOrder) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/requestList?$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += '&$orderby=requestedDateTime desc'
    }
    return requests.getWithToken(url, access_token);
  },
};

const Zone = {
  getZoneData: (access_token, currentPage = 1, pageSize = 10, sortDirection, sortOrder) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/zonelist?$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += `&$orderby=createdDateTime desc`
    }
    return requests.getWithToken(url, access_token);
  },
  getAssignableZones: (access_token, searchValue) => {
    const _ = require('lodash');
    const data = _.upperFirst(searchValue)
    return requests.getWithToken(`${apiUrl}/api/zone/assignable?key=${data}`, access_token);
  },
  create: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/zone/create`, data, access_token)
  },
  update: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/zone/update`, data, access_token)
  },
};
const Device = {
  addDevices: (access_token, devices) => {
    return requests.postWithToken(`${apiUrl}/api/device/add`, devices, access_token);
  },
  getDevices: (access_token, currentPage = 1, pageSize = 10, searchDeviceKey, searchUid, searchModelNo, searchName, searchIsReturned, searchHardwareVersion, searchFirmwareVersion, searchOrgName, searchAssignedByUserEmail, searchAssignedUserDisplayName, searchAssignedUserEmail, searchAssignedUserRoleName, searchIsAssigned, searchIsActive, searchIsDeleted, searchEndCustomerName, searchEndCustomerEmail, searchroomName, searchCreatedDateTime, sortDirection, sortOrder) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/devicelist?$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += `&$orderby=deviceKey desc`;
    }
    if (searchDeviceKey || searchUid || searchModelNo || searchName || searchIsReturned || searchHardwareVersion || searchFirmwareVersion || searchOrgName || searchAssignedByUserEmail || searchAssignedUserDisplayName || searchAssignedUserEmail || searchAssignedUserRoleName || searchIsAssigned || searchIsActive || searchIsDeleted || searchEndCustomerName || searchEndCustomerEmail || searchroomName || searchCreatedDateTime) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchDeviceKey) {
        if (searchDeviceKey.toLowerCase() === 'na') {
          filterArray.push('deviceKey eq null');
        } else {
          filterArray.push(`deviceKey eq ${encodeURIComponent(searchDeviceKey)}`);
        }
      }
      if (searchUid) {
        if (searchUid.toLowerCase() === 'na') {
          filterArray.push('uid eq null');
        } else {
          filterArray.push(`contains(uid,'${encodeURIComponent(searchUid)}')`);
        }
      }
      if (searchModelNo) {
        if (searchModelNo.toLowerCase() === 'na') {
          filterArray.push('modelNo eq null');
        } else {
          filterArray.push(`contains(tolower(modelNo),tolower('${encodeURIComponent(searchModelNo)}'))`);
        }
      }
      if (searchName) {
        if (searchName.toLowerCase() === 'na') {
          filterArray.push('name eq null');
        } else {
          filterArray.push(`contains(tolower(name),tolower('${encodeURIComponent(searchName)}'))`);
        }
      }
      if (searchIsReturned) {
        if (searchIsReturned.toLowerCase() === 'all') {
          filterArray.push('((isReturned eq true) or (isReturned eq false))');
        } else {
          filterArray.push(`isReturned eq ${encodeURIComponent(searchIsReturned)}`);
        }
      }
      if (searchHardwareVersion) {
        if (searchHardwareVersion.toLowerCase() === 'na') {
          filterArray.push('((hardwareVersion eq null) or (firmwareVersion eq null))');
        } else {
          // filterArray.push(`hardwareVersion eq ${searchHardwareVersion}`);
          filterArray.push(`(contains(tolower(hardwareVersion),tolower('${encodeURIComponent(searchHardwareVersion)}')) or contains(tolower(firmwareVersion),tolower('${encodeURIComponent(searchHardwareVersion)}')))`);
        }
      }
      if (searchFirmwareVersion) {
        if (searchFirmwareVersion.toLowerCase() === 'na') {
          filterArray.push('firmwareVersion eq null');
        } else {
          filterArray.push(`contains(tolower(firmwareVersion),tolower('${encodeURIComponent(searchFirmwareVersion)}'))`);
        }
      }
      if (searchOrgName) {
        if (searchOrgName.toLowerCase() === 'na') {
          filterArray.push('orgName eq null');
        } else {
          filterArray.push(`contains(tolower(orgName),tolower('${encodeURIComponent(searchOrgName)}'))`);
        }
      }
      if (searchAssignedUserDisplayName) {
        if (searchAssignedUserDisplayName.toLowerCase() === 'na') {
          filterArray.push('assignedUserDisplayName eq null');
        } else {
          filterArray.push(`contains(tolower(assignedUserDisplayName),tolower('${encodeURIComponent(searchAssignedUserDisplayName)}'))`);
        }
      }
      if (searchAssignedByUserEmail) {
        if (searchAssignedByUserEmail.toLowerCase() === 'na') {
          filterArray.push('((assignedByUserEmail eq null) or (assignedByUserEmail eq \'NA\') or (assignedByUserName eq null) or (assignedByUserName eq \'NA\'))');
        } else {
          filterArray.push(`(contains(tolower(assignedByUserEmail),tolower('${encodeURIComponent(searchAssignedByUserEmail)}')) or contains(tolower(assignedByUserName),tolower('${encodeURIComponent(searchAssignedByUserEmail)}')))`);
        }
      }
      if (searchAssignedUserEmail) {
        if (searchAssignedUserEmail.toLowerCase() === 'na') {
          filterArray.push('((assignedUserEmail eq null) or (assignedUserEmail eq \'NA\') or (assignedUserDisplayName eq null) or (assignedUserDisplayName eq \'NA\'))');
        } else {
          filterArray.push(`(contains(tolower(assignedUserEmail),tolower('${encodeURIComponent(searchAssignedUserEmail)}')) or contains(tolower(assignedUserDisplayName),tolower('${encodeURIComponent(searchAssignedUserEmail)}')))`);
        }
      }
      if (searchAssignedUserRoleName) {
        if (searchAssignedUserRoleName.toLowerCase() === 'na') {
          filterArray.push('assignedUserRoleName eq null');
        } else {
          filterArray.push(`assignedUserRoleName eq '${encodeURIComponent(searchAssignedUserRoleName)}'`);
        }
      }
      if (searchIsAssigned) {
        if (searchIsAssigned.toLowerCase() === 'all') {
          filterArray.push('((isAssigned eq true) or (isAssigned eq false))');
        } else {
          filterArray.push(`isAssigned eq ${encodeURIComponent(searchIsAssigned)}`);
        }
      }
      if (searchIsActive) {
        if (searchIsActive.toLowerCase() === 'all') {
          filterArray.push('((isActive eq true) or (isActive eq false))');
        } else {
          filterArray.push(`isActive eq ${encodeURIComponent(searchIsActive)}`);
        }
      }
      if (searchIsDeleted) {
        if (searchIsDeleted.toLowerCase() === 'all') {
          filterArray.push('((isDeleted eq true) or (isDeleted eq false))');
        } else {
          filterArray.push(`isDeleted eq ${encodeURIComponent(searchIsDeleted)}`);
        }
      }
      if (searchEndCustomerName) {
        if (searchEndCustomerName.toLowerCase() === 'na') {
          filterArray.push('endCustomerName eq null');
        } else {
          filterArray.push(`contains(tolower(endCustomerName),tolower('${encodeURIComponent(searchEndCustomerName)}'))`);
        }
      }
      if (searchEndCustomerEmail) {
        if (searchEndCustomerEmail.toLowerCase() === 'na') {
          filterArray.push('((endCustomerEmail eq null) or (endCustomerEmail eq \'NA\') or (endCustomerName eq \'NA\') or (endCustomerName eq null))');
        } else {
          filterArray.push(`(contains(tolower(endCustomerEmail),tolower('${encodeURIComponent(searchEndCustomerEmail)}')) or contains(tolower(endCustomerName),tolower('${encodeURIComponent(searchEndCustomerEmail)}')))`);
        }
      }
      if (searchroomName) {
        if (searchroomName.toLowerCase() === 'na') {
          filterArray.push('roomName eq null');
        } else {
          filterArray.push(`contains(tolower(roomName),tolower('${encodeURIComponent(searchroomName)}'))`);
        }
      }
      if (searchCreatedDateTime) {
        if (searchCreatedDateTime.toLowerCase() === 'na') {
          filterArray.push('createdDateTime eq null');
        } else {
          filterArray.push(`createdDateTime eq ${encodeURIComponent(searchCreatedDateTime)}`);
        }
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }
    return requests.getWithToken(url, access_token);
  },
  getLatestDevices: (access_token, currentPage = 1, pageSize = 10, searchDeviceKey, searchUid, searchModelNo, searchName, searchIsReturned, searchHardwareVersion, searchFirmwareVersion, searchOrgName, searchAssignedUserDisplayName, searchAssignedUserEmail, searchAssignedUserRoleName, searchIsAssigned, searchIsActive, searchIsDeleted, searchEndCustomerName, searchEndCustomerEmail, searchroomName, searchCreatedDateTime, sortDirection, sortOrder) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/LatestDeviceList?$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += `&$orderby=deviceKey desc`;
    }
    if (searchDeviceKey || searchUid || searchModelNo || searchName || searchIsReturned || searchHardwareVersion || searchFirmwareVersion || searchOrgName || searchAssignedUserDisplayName || searchAssignedUserEmail || searchAssignedUserRoleName || searchIsAssigned || searchIsActive || searchIsDeleted || searchEndCustomerName || searchEndCustomerEmail || searchroomName || searchCreatedDateTime) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchDeviceKey) {
        if (searchDeviceKey.toLowerCase() === 'na') {
          filterArray.push('deviceKey eq null');
        } else {
          filterArray.push(`deviceKey eq ${encodeURIComponent(searchDeviceKey)}`);
        }
      }
      if (searchUid) {
        if (searchUid.toLowerCase() === 'na') {
          filterArray.push('uid eq null');
        } else {
          filterArray.push(`contains(tolower(uid),tolower('${encodeURIComponent(searchUid)}'))`);
        }
      }
      if (searchModelNo) {
        if (searchModelNo.toLowerCase() === 'na') {
          filterArray.push('modelNo eq null');
        } else {
          filterArray.push(`contains(tolower(modelNo),tolower('${encodeURIComponent(searchModelNo)}'))`);
        }
      }
      if (searchName) {
        if (searchName.toLowerCase() === 'na') {
          filterArray.push('name eq null');
        } else {
          filterArray.push(`contains(tolower(name),tolower('${encodeURIComponent(searchName)}'))`);
        }
      }
      if (searchIsReturned) {
        if (searchIsReturned.toLowerCase() === 'all') {
          filterArray.push('((isReturned eq true) or (isReturned eq false))');
        } else {
          filterArray.push(`isReturned eq ${encodeURIComponent(searchIsReturned)}`);
        }
      }
      if (searchHardwareVersion) {
        if (searchHardwareVersion.toLowerCase() === 'na') {
          filterArray.push('hardwareVersion eq null');
        } else {
          // filterArray.push(`hardwareVersion eq ${searchHardwareVersion}`);
          filterArray.push(`contains(tolower(hardwareVersion),tolower('${encodeURIComponent(searchHardwareVersion)}'))`);
        }
      }
      if (searchFirmwareVersion) {
        if (searchFirmwareVersion.toLowerCase() === 'na') {
          filterArray.push('firmwareVersion eq null');
        } else {
          filterArray.push(`contains(tolower(firmwareVersion),tolower('${encodeURIComponent(searchFirmwareVersion)}'))`);
        }
      }
      if (searchOrgName) {
        if (searchOrgName.toLowerCase() === 'na') {
          filterArray.push('orgName eq null');
        } else {
          filterArray.push(`contains(tolower(orgName),tolower('${encodeURIComponent(searchOrgName)}'))`);
        }
      }
      if (searchAssignedUserDisplayName) {
        if (searchAssignedUserDisplayName.toLowerCase() === 'na') {
          filterArray.push('assignedUserDisplayName eq null');
        } else {
          filterArray.push(`contains(tolower(assignedUserDisplayName),tolower('${encodeURIComponent(searchAssignedUserDisplayName)}'))`);
        }
      }
      if (searchAssignedUserEmail) {
        if (searchAssignedUserEmail.toLowerCase() === 'na') {
          filterArray.push('((assignedUserEmail eq null) or (assignedUserEmail eq \'NA\') or (assignedUserDisplayName eq null) or (assignedUserDisplayName eq \'NA\'))');
        } else {
          filterArray.push(`(contains(tolower(assignedUserEmail),tolower('${encodeURIComponent(searchAssignedUserEmail)}')) or contains(tolower(assignedUserDisplayName),tolower('${encodeURIComponent(searchAssignedUserEmail)}')))`);
        }
      }
      if (searchAssignedUserRoleName) {
        if (searchAssignedUserRoleName.toLowerCase() === 'na') {
          filterArray.push('assignedUserRoleName eq null');
        } else {
          filterArray.push(`assignedUserRoleName eq '${encodeURIComponent(searchAssignedUserRoleName)}'`);
        }
      }
      if (searchIsAssigned) {
        if (searchIsAssigned.toLowerCase() === 'all') {
          filterArray.push('(isAssigned eq true) or (isAssigned eq false)');
        } else {
          filterArray.push(`isAssigned eq ${encodeURIComponent(searchIsAssigned)}`);
        }
      }
      if (searchIsActive) {
        if (searchIsActive.toLowerCase() === 'all') {
          filterArray.push('(isActive eq true) or (isActive eq false)');
        } else {
          filterArray.push(`isActive eq ${encodeURIComponent(searchIsActive)}`);
        }
      }
      if (searchIsDeleted) {
        if (searchIsDeleted.toLowerCase() === 'all') {
          filterArray.push('((isDeleted eq true) or (isDeleted eq false))');
        } else {
          filterArray.push(`isDeleted eq ${encodeURIComponent(searchIsDeleted)}`);
        }
      }
      if (searchEndCustomerName) {
        if (searchEndCustomerName.toLowerCase() === 'na') {
          filterArray.push('endCustomerName eq null');
        } else {
          filterArray.push(`contains(tolower(endCustomerName),tolower('${encodeURIComponent(searchEndCustomerName)}'))`);
        }
      }
      if (searchEndCustomerEmail) {
        if (searchEndCustomerEmail.toLowerCase() === 'na') {
          filterArray.push('endCustomerEmail eq null');
        } else {
          filterArray.push(`contains(tolower(endCustomerEmail),tolower('${encodeURIComponent(searchEndCustomerEmail)}'))`);
        }
      }
      if (searchroomName) {
        if (searchroomName.toLowerCase() === 'na') {
          filterArray.push('roomName eq null');
        } else {
          filterArray.push(`contains(tolower(roomName),tolower('${encodeURIComponent(searchroomName)}'))`);
        }
      }
      if (searchCreatedDateTime) {
        if (searchCreatedDateTime.toLowerCase() === 'na') {
          filterArray.push('createdDateTime eq null');
        } else {
          filterArray.push(`createdDateTime eq ${encodeURIComponent(searchCreatedDateTime)}`);
        }
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }
    return requests.getWithToken(url, access_token);
  },
  // getLatestDevices: (access_token) => {
  //   return requests.getWithToken(`${apiUrl}/odata/LatestDeviceList?$orderby=deviceKey desc`, access_token);
  // },
  getOrganisations: (access_token, searchValue) => {
    let url = `${apiUrl}/odata/orglist?$orderby=createdDateTime desc&$filter=active eq true and orgType eq 'general'`;
    if (searchValue) {
      url += ` and contains(tolower(name), tolower('${searchValue}'))`
    }
    return requests.getWithToken(url, access_token)
  },
  assignDevices: (access_token, deviceAssignObj) => {
    return requests.postWithToken(`${apiUrl}/api/device/assign`, deviceAssignObj, access_token);
  },
  deleteDevice: (access_token, devices) => {
    return requests.deleteWithTokenAndBody(`${apiUrl}/api/device/Delete`, devices, access_token);
  },
  getDeviceCycle: (access_token, deviceId) => {
    return requests.getWithToken(`${apiUrl}/api/device/details?devId=${deviceId}`, access_token);
  },
  getDeviceLogs: (access_token, deviceId) => {
    return requests.getWithToken(`${apiUrl}/api/device/TransactionLog?uid=${deviceId}`, access_token);
  },
  createMasterDevice: (access_token, masterDeviceObj) => {
    return requests.postWithToken(`${apiUrl}/api/device/master/create`, masterDeviceObj, access_token);
  },
  createMasterDeviceKey: (access_token) => {
    return requests.getWithToken(`${apiUrl}/api/device/master-device-key`, access_token);
  },
  getMasterDevices: (access_token, currentPage = 1, pageSize = 10, searchUid, searchfriendlyName, searchIsActive, searchAssignedDeviceCount, searchAssignedByUserEmail, searchEndCustomerName, searchEndCustomerEmail, searchEndCustomerZone, searchEndCustomerZip, searchSubscriptionValidity, searchCreatedDateTime, sortOrder, sortDirection) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/masterdevicelist?$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += `&$orderby=updatedDate desc`;
    }
    if (searchfriendlyName || searchIsActive || searchAssignedDeviceCount || searchSubscriptionValidity || searchCreatedDateTime || searchAssignedByUserEmail || searchEndCustomerEmail) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchfriendlyName) {
        if (searchfriendlyName.toLowerCase() === 'na') {
          filterArray.push('friendlyName eq null');
        } else {
          filterArray.push(`contains(tolower(friendlyName), tolower('${searchfriendlyName}'))`);
        }
      }
      if (searchIsActive) {
        if (searchIsActive.toLowerCase() === 'all') {
          filterArray.push('(isActive eq true) or (isActive eq false)');
        } else {
          filterArray.push(`isActive eq ${searchIsActive}`);
        }
      }
      if (searchAssignedDeviceCount) {
        if (searchAssignedDeviceCount.toLowerCase() === 'na') {
          filterArray.push('assignedDeviceCount eq null');
        } else {
          filterArray.push(`assignedDeviceCount eq ${searchAssignedDeviceCount}`);
        }
      }
      if (searchSubscriptionValidity) {
        if (searchSubscriptionValidity.toLowerCase() === 'na') {
          filterArray.push('subscriptionValidity eq null');
        } else {
          filterArray.push(`subscriptionValidity eq ${searchSubscriptionValidity}`);
        }
      }
      if (searchCreatedDateTime) {
        if (searchCreatedDateTime.toLowerCase() === 'na') {
          filterArray.push('createdDateTime eq null');
        } else {
          filterArray.push(`createdDateTime eq ${searchCreatedDateTime}`);
        }
      }
      if (searchAssignedByUserEmail) {
        if (searchAssignedByUserEmail.toLowerCase() === 'na') {
          filterArray.push('((assignedByUserEmail eq null) or (assignedByUserName eq null))');
        } else {
          filterArray.push(`(contains(tolower(assignedByUserEmail),tolower('${searchAssignedByUserEmail}')) or contains(tolower(assignedByUserName),tolower('${searchAssignedByUserEmail}')))`);
        }
      }
      if (searchEndCustomerEmail) {
        if (searchEndCustomerEmail.toLowerCase() === 'na') {
          filterArray.push('((endCustomerEmail eq null) or (endCustomerName eq null))');
        } else {
          filterArray.push(`(contains(tolower(endCustomerEmail),tolower('${searchEndCustomerEmail}')) or contains(tolower(endCustomerName),tolower('${searchEndCustomerEmail}')))`);
        }
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }
    if (searchUid) {
      url = url + `&uid=${searchUid}`;
    }
    // if (searchEndCustomerEmail) {
    //   url = url + `&endCustomerEmail=${encodeURIComponent(searchEndCustomerEmail)}`;
    // }
    // if (searchEndCustomerName) {
    //   url = url + `&endCustomerName=${searchEndCustomerName}`;
    // }
    if (searchEndCustomerZone) {
      url = url + `&endCustomerZone=${searchEndCustomerZone}`;
    }
    if (searchEndCustomerZip) {
      url = url + `&endCustomerZip=${searchEndCustomerZip}`;
    }
    return requests.getWithToken(url, access_token);
  },
  getMasterDevicesListByCustomer: (access_token, currentPage = 1, pageSize = 10, searchUid, searchfriendlyName, searchIsActive, searchAssignedDeviceCount, searchAssignedByUserEmail, searchEndCustomerName, searchEndCustomerEmail, searchEndCustomerZone, searchEndCustomerZip, searchSubscriptionValidity, searchCreatedDateTime, sortOrder, sortDirection) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/MasterDevicesByCustomer?$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += `&$orderby=updatedDate desc`;
    }
    if (searchfriendlyName || searchIsActive || searchAssignedDeviceCount || searchSubscriptionValidity || searchCreatedDateTime || searchAssignedByUserEmail || searchEndCustomerEmail) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchfriendlyName) {
        if (searchfriendlyName.toLowerCase() === 'na') {
          filterArray.push('friendlyName eq null');
        } else {
          filterArray.push(`contains(tolower(friendlyName), tolower('${searchfriendlyName}'))`);
        }
      }
      if (searchIsActive) {
        if (searchIsActive.toLowerCase() === 'all') {
          filterArray.push('(isActive eq true) or (isActive eq false)');
        } else {
          filterArray.push(`isActive eq ${searchIsActive}`);
        }
      }
      if (searchAssignedDeviceCount) {
        if (searchAssignedDeviceCount.toLowerCase() === 'na') {
          filterArray.push('assignedDeviceCount eq null');
        } else {
          filterArray.push(`assignedDeviceCount eq ${searchAssignedDeviceCount}`);
        }
      }
      if (searchSubscriptionValidity) {
        if (searchSubscriptionValidity.toLowerCase() === 'na') {
          filterArray.push('subscriptionValidity eq null');
        } else {
          filterArray.push(`subscriptionValidity eq ${searchSubscriptionValidity}`);
        }
      }
      if (searchCreatedDateTime) {
        if (searchCreatedDateTime.toLowerCase() === 'na') {
          filterArray.push('createdDateTime eq null');
        } else {
          filterArray.push(`createdDateTime eq ${searchCreatedDateTime}`);
        }
      }
      if (searchAssignedByUserEmail) {
        if (searchAssignedByUserEmail.toLowerCase() === 'na') {
          filterArray.push('((assignedByUserEmail eq null) or (assignedByUserName eq null))');
        } else {
          filterArray.push(`(contains(tolower(assignedByUserEmail),tolower('${searchAssignedByUserEmail}')) or contains(tolower(assignedByUserName),tolower('${searchAssignedByUserEmail}')))`);
        }
      }
      if (searchEndCustomerEmail) {
        if (searchEndCustomerEmail.toLowerCase() === 'na') {
          filterArray.push('((endCustomerEmail eq null) or (endCustomerName eq null))');
        } else {
          filterArray.push(`(contains(tolower(endCustomerEmail),tolower('${searchEndCustomerEmail}')) or contains(tolower(endCustomerName),tolower('${searchEndCustomerEmail}')))`);
        }
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }
    if (searchUid) {
      url = url + `&uid=${searchUid}`;
    }
    // if (searchEndCustomerEmail) {
    //   url = url + `&endCustomerEmail=${encodeURIComponent(searchEndCustomerEmail)}`;
    // }
    // if (searchEndCustomerName) {
    //   url = url + `&endCustomerName=${searchEndCustomerName}`;
    // }
    if (searchEndCustomerZone) {
      url = url + `&endCustomerZone=${searchEndCustomerZone}`;
    }
    if (searchEndCustomerZip) {
      url = url + `&endCustomerZip=${searchEndCustomerZip}`;
    }
    return requests.getWithToken(url, access_token);
  },
  getDeviceDetails: (access_token, deviceId) => {
    return requests.getWithToken(`${apiUrl}/api/device/details?devId=${deviceId}`, access_token);
  },
  getSchedulerDetails: (access_token, id) => {
    return requests.getWithToken(`${apiUrl}/api/device/scheduler/details?switchId=${id}`, access_token);
  },
  updateDevice: (access_token, device) => {
    return requests.postWithToken(`${apiUrl}/api/device/update`, device, access_token);
  },
  getMasterDeviceDetails: (access_token, masterDeviceId) => {
    return requests.getWithToken(`${apiUrl}/api/device/master/details?masterDevId=${masterDeviceId}`, access_token);
  },
  updateMasterDevice: (access_token, device) => {
    return requests.postWithToken(`${apiUrl}/api/device/master/update`, device, access_token);
  },
  mapNewDevice: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/device/master/map-devices`, data, access_token);
  },
  updateRoomDetails: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/device/update/room`, data, access_token);
  },
  removeMappedDevice: (access_token, masterDeviceId, deviceKey) => {
    const data = {
      masterDeviceId: masterDeviceId,
      devicekey: deviceKey,
    };
    return requests.postWithToken(`${apiUrl}/api/device/master/remove-device`, data, access_token);
  },
  getUnAssignedDevices: (access_token, searchValue) => {
    return requests.getWithToken(`${apiUrl}/api/device/unassigned`, access_token);
  },
  getAssinableGroups: (access_token, masterDeviceId) => {
    return requests.getWithToken(`${apiUrl}/api/device/assignable/groups?masterDeviceId=${masterDeviceId}`, access_token);
  },
  getAssignableSwitchCategory: (access_token, searchValue) => {
    let url = `${apiUrl}/odata/switchcategorieslist?$orderby=categoryName asc`;
    if (searchValue) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchValue) {
        filterArray.push(`contains(tolower(categoryName), tolower('${searchValue}'))`)
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }

    return requests.getWithToken(url, access_token)
  },
  createGroup: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/device/group/create`, data, access_token);
  },
  updateGroup: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/device/group/update`, data, access_token);
  },
  exportData: (access_token) => {
    return requests.getWithToken(`${apiUrl}/odata/devicelist/export?$orderby=deviceKey desc`, access_token)
  },
  exportLatestDevice: (access_token) => {
    return requests.getWithToken(`${apiUrl}/odata/LatestDeviceList/Export?$orderby=deviceKey desc`, access_token)
  },
  exportMasterData: (access_token) => {
    return requests.getWithToken(`${apiUrl}/odata/masterdevicelist/export?$orderby=updatedDate desc`, access_token)
  },
  exportMasterDataByCustomer: (access_token) => {
    return requests.getWithToken(`${apiUrl}/odata/MasterDevicesByCustomer/export?$orderby=updatedDate desc`, access_token)
  },
  getLastSerialNumber: (access_token) => {
    return requests.getWithToken(`${apiUrl}/api/device/maxserialno`, access_token)
  },
  getCurrentUserUnAssignedDevices: (access_token, userId) => {
    return requests.getWithToken(`${apiUrl}/api/device/unassigned/${userId}`, access_token);
  },
  transferDevices: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/device/transfer`, data, access_token);
  }
};
const ReturnRequests = {
  addReturnRequest: (access_token, devices) => {
    return requests.postWithToken(`${apiUrl}/api/device/returndevice`, devices, access_token);
  },
  getAssignedDevices: (access_token, searchValue, isEndUser) => {
    let url = `${apiUrl}/odata/DeviceToReturnList?$orderby=deviceKey desc`;
    if (isEndUser) {
      if (searchValue) {
        if (!isNaN((Number(searchValue)))) {
          url += `&$filter=(deviceKey eq ${searchValue} or contains(tolower(friendlyName),tolower('${searchValue}')) or contains(tolower(roomName),tolower('${searchValue}')))`;
        }
        else {
          url += `&$filter=(contains(tolower(friendlyName),tolower('${searchValue}')) or contains(tolower(roomName),tolower('${searchValue}')))`;
        }
      }
    }
    else if (searchValue) {
      if (!isNaN((Number(searchValue)))) {
        url += `&$filter=(deviceKey eq ${searchValue} or contains(tolower(name),tolower('${searchValue}')))`;
      }
      else {
        url += `&$filter=contains(tolower(name),tolower('${searchValue}'))`;
      }
    }
    return requests.getWithToken(url, access_token);
  },
  getReasons: (access_token, searchValue) => {
    let url = `${apiUrl}/odata/ReturnReasonList?$select=Reason,Id&$filter=IsActive eq true`;
    if (searchValue) {
      url += ` and (contains(tolower(Reason), tolower('${encodeURIComponent(searchValue)}'))`;
    }
    return requests.getWithToken(url, access_token);
  },
  getReturnRequests: (access_token, currentPage = 1, pageSize = 10, searchDeviceKey, searchRequestStatus, searchRequestCreatedTimeStamp, searchRequestedTo, searchRequestReason, searchRequestNotes, searchStatusUpdatedTieStamp, searchStatusUpdatedReason, sortDirection, sortOrder) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/ReturnRequestList?$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += `&$orderby=requestCreatedTimeStamp desc`;
    }
    if (searchDeviceKey || searchRequestStatus || searchRequestCreatedTimeStamp || searchRequestedTo || searchRequestReason || searchRequestNotes || searchStatusUpdatedTieStamp || searchStatusUpdatedReason) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchDeviceKey) {
        if (searchDeviceKey.toLowerCase() === 'na') {
          const filterDeviceKey = `deviceList/any(c: c/deviceKey eq null)`
          filterArray.push(encodeURIComponent(filterDeviceKey));
        } else {
          const filterDeviceKey = `deviceList/any(c: c/deviceKey eq ${searchDeviceKey})`
          filterArray.push(encodeURIComponent(filterDeviceKey));
        }
      }
      if (searchRequestStatus) {
        if (searchRequestStatus.toLowerCase() === 'na') {
          filterArray.push('requestStatus eq null');
        } else {
          filterArray.push(`contains(tolower(requestStatus),tolower('${searchRequestStatus}'))`);
        }
      }
      if (searchRequestCreatedTimeStamp) {
        if (searchRequestCreatedTimeStamp.toLowerCase() === 'na') {
          filterArray.push('requestCreatedTimeStamp eq null');
        } else {
          filterArray.push(`requestCreatedTimeStamp eq ${searchRequestCreatedTimeStamp}`);
        }
      }
      if (searchRequestedTo) {
        if (searchRequestedTo.toLowerCase() === 'na') {
          filterArray.push('((requestedToDisplayName eq null) or (requestedToEmail eq null)) or (requestedToUserRole eq null))');
        } else {
          filterArray.push(`(contains(tolower(requestedToDisplayName),tolower('${searchRequestedTo}')) or contains(tolower(requestedToEmail),tolower('${searchRequestedTo}')) or contains(tolower(requestedToUserRole),tolower('${searchRequestedTo}')))`);
        }
      }
      if (searchRequestReason) {
        if (searchRequestReason.toLowerCase() === 'na') {
          filterArray.push('requestReason eq null');
        } else {
          filterArray.push(`contains(tolower(requestReason),tolower('${searchRequestReason}'))`);
        }
      }
      if (searchRequestNotes) {
        if (searchRequestNotes.toLowerCase() === 'na') {
          filterArray.push('requestNotes eq null');
        } else {
          filterArray.push(`contains(tolower(requestNotes),tolower('${searchRequestNotes}'))`);
        }
      }
      if (searchStatusUpdatedTieStamp) {
        if (searchStatusUpdatedTieStamp.toLowerCase() === 'na') {
          filterArray.push('statusUpdatedTieStamp eq null');
        } else {
          filterArray.push(`statusUpdatedTieStamp eq ${searchStatusUpdatedTieStamp}`);
        }
      }
      if (searchStatusUpdatedReason) {
        if (searchStatusUpdatedReason.toLowerCase() === 'na') {
          filterArray.push('statusUpdatedReason eq null');
        } else {
          filterArray.push(`contains(tolower(statusUpdatedReason),tolower('${searchStatusUpdatedReason}'))`);
        }
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }
    return requests.getWithToken(url, access_token);
  },
};
const ReturnApproval = {
  submitReturnApproval: (access_token, approvalData) => {
    return requests.postWithToken(`${apiUrl}/api/device/UpdateReturnRequest`, approvalData, access_token);
  },
  getAssignedDevices: (access_token, searchValue) => {
    let url = `${apiUrl}/odata/devicelist?$orderby=deviceKey desc`;
    if (searchValue) {
      url += `&$filter=deviceKey eq ${searchValue}`;
    }
    return requests.getWithToken(url, access_token);
  },
  getReturnApprovalsCount: (access_token) => {
    return requests.getWithToken(`${apiUrl}/odata/ReturnRequestList?RequestType=MyApprovals&$count=true&$filter=contains(tolower(requestStatus), tolower('Submitted'))`, access_token);
  },
  getReturnApprovals: (access_token, currentPage = 1, pageSize = 10, searchDeviceKey, searchRequestStatus, searchRequestCreatedTimeStamp, searchRequestedBy, searchRequestReason, searchRequestNotes, searchStatusUpdatedTieStamp, searchStatusUpdatedReason, sortDirection, sortOrder) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/ReturnRequestList?RequestType=MyApprovals&$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += `&$orderby=requestCreatedTimeStamp desc`;
    }
    if (searchDeviceKey || searchRequestStatus || searchRequestCreatedTimeStamp || searchRequestedBy || searchRequestReason || searchRequestNotes || searchStatusUpdatedTieStamp || searchStatusUpdatedReason) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchDeviceKey) {
        if (searchDeviceKey.toLowerCase() === 'na') {
          const filterDeviceKey = `deviceList/any(c: c/deviceKey eq null)`
          filterArray.push(encodeURIComponent(filterDeviceKey));
        } else {
          const filterDeviceKey = `deviceList/any(c: c/deviceKey eq ${searchDeviceKey})`
          filterArray.push(encodeURIComponent(filterDeviceKey));
        }
      }
      if (searchRequestStatus) {
        if (searchRequestStatus.toLowerCase() === 'na') {
          filterArray.push('requestStatus eq null');
        } else {
          filterArray.push(`contains(tolower(requestStatus),tolower('${searchRequestStatus}'))`);
        }
      }
      if (searchRequestCreatedTimeStamp) {
        if (searchRequestCreatedTimeStamp.toLowerCase() === 'na') {
          filterArray.push('requestCreatedTimeStamp eq null');
        } else {
          filterArray.push(`requestCreatedTimeStamp eq ${searchRequestCreatedTimeStamp}`);
        }
      }
      if (searchRequestedBy) {
        if (searchRequestedBy.toLowerCase() === 'na') {
          filterArray.push('((requestedByDisplayName eq null) or (requestedByEmail eq null)) or (requestedByUserRole eq null))');
        } else {
          filterArray.push(`(contains(tolower(requestedByDisplayName),tolower('${searchRequestedBy}')) or contains(tolower(requestedByEmail),tolower('${searchRequestedBy}')) or contains(tolower(requestedByUserRole),tolower('${searchRequestedBy}')))`);
        }
      }
      if (searchRequestReason) {
        if (searchRequestReason.toLowerCase() === 'na') {
          filterArray.push('requestReason eq null');
        } else {
          filterArray.push(`contains(tolower(requestReason),tolower('${searchRequestReason}'))`);
        }
      }
      if (searchRequestNotes) {
        if (searchRequestNotes.toLowerCase() === 'na') {
          filterArray.push('requestNotes eq null');
        } else {
          filterArray.push(`contains(tolower(requestNotes),tolower('${searchRequestNotes}'))`);
        }
      }
      if (searchStatusUpdatedTieStamp) {
        if (searchStatusUpdatedTieStamp.toLowerCase() === 'na') {
          filterArray.push('statusUpdatedTieStamp eq null');
        } else {
          filterArray.push(`statusUpdatedTieStamp eq ${searchStatusUpdatedTieStamp}`);
        }
      }
      if (searchStatusUpdatedReason) {
        if (searchStatusUpdatedReason.toLowerCase() === 'na') {
          filterArray.push('statusUpdatedReason eq null');
        } else {
          filterArray.push(`contains(tolower(statusUpdatedReason),tolower('${searchStatusUpdatedReason}'))`);
        }
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }
    return requests.getWithToken(url, access_token);
  },
};

const Product = {
  getProductData: (access_token, currentPage = 1, pageSize = 10, searchProductName, searchIsActive, searchCreatedBy, searchCreatedDateTime, searchUpdatedBy, searchUpdatedDateTime, sortDirection, sortOrder) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/productlist?$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += `&$orderby=createdDateTime desc`
    }
    if (searchProductName || searchIsActive || searchCreatedBy || searchCreatedDateTime || searchUpdatedBy || searchUpdatedDateTime) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchProductName) {
        if (searchProductName.toLowerCase() === 'na') {
          filterArray.push('name eq null');
        } else {
          filterArray.push(`contains(tolower(name),tolower('${searchProductName}'))`);
        }
      }
      if (searchIsActive) {
        if (searchIsActive.toLowerCase() === 'na') {
          filterArray.push('searchIsActive eq null');
        } else {
          filterArray.push(`userCount eq ${searchIsActive}`);
        }
      }
      if (searchCreatedBy) {
        if (searchCreatedBy.toLowerCase() === 'na') {
          filterArray.push('deviceCount eq null');
        } else {
          filterArray.push(`deviceCount eq ${searchCreatedBy}`);
        }
      }
      if (searchCreatedDateTime) {
        if (searchCreatedDateTime.toLowerCase() === 'na') {
          filterArray.push('address eq null');
        } else {
          filterArray.push(`contains(tolower(address),tolower('${searchCreatedDateTime}'))`);
        }
      }
      if (searchUpdatedBy) {
        if (searchUpdatedBy.toLowerCase() === 'na') {
          filterArray.push('address eq null');
        } else {
          filterArray.push(`contains(tolower(address),tolower('${searchUpdatedBy}'))`);
        }
      }
      if (searchUpdatedDateTime) {
        if (searchUpdatedDateTime.toLowerCase() === 'na') {
          filterArray.push('active eq null');
        } else {
          filterArray.push(`active eq ${searchUpdatedDateTime}`);
        }
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }
    return requests.getWithToken(url, access_token);
  },
  create: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/product/create`, data, access_token)
  },
  update: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/product/update`, data, access_token)
  },
  getAssignableProducts: (access_token, searchValue) => {
    return requests.getWithToken(`${apiUrl}/api/product/assignable?key=${searchValue}`, access_token);
  },
};

const AppVersion = {
  getAppVersionList: (access_token, currentPage = 1, pageSize = 10, searchVersionNo, searchNotes, searchReleasedDate, searchCreatedBy, searchCreatedDateTime, searchUpdatedBy, searchUpdatedDateTime, sortDirection, sortOrder) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/AppVersionList?$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += `&$orderby=releasedDate desc`
    }
    if (searchVersionNo || searchNotes || searchReleasedDate || searchCreatedBy || searchCreatedDateTime || searchUpdatedBy || searchUpdatedDateTime) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchVersionNo) {
        if (searchVersionNo.toLowerCase() === 'na') {
          filterArray.push('versionNo eq null');
        } else {
          filterArray.push(`contains(tolower(versionNo),tolower('${searchVersionNo}'))`);
        }
      }
      if (searchNotes) {
        if (searchNotes.toLowerCase() === 'na') {
          filterArray.push('notes eq null');
        } else {
          filterArray.push(`contains(tolower(notes),tolower('${searchNotes}'))`);
        }
      }
      if (searchReleasedDate) {
        if (searchReleasedDate.toLowerCase() === 'na') {
          filterArray.push('releasedDate eq null');
        } else {
          filterArray.push(`releasedDate eq ${searchReleasedDate}`);
        }
      }
      if (searchCreatedBy) {
        if (searchCreatedBy.toLowerCase() === 'na') {
          filterArray.push('deviceCount eq null');
        } else {
          filterArray.push(`deviceCount eq ${searchCreatedBy}`);
        }
      }
      if (searchCreatedDateTime) {
        if (searchCreatedDateTime.toLowerCase() === 'na') {
          filterArray.push('address eq null');
        } else {
          filterArray.push(`contains(tolower(address),tolower('${searchCreatedDateTime}'))`);
        }
      }
      if (searchUpdatedBy) {
        if (searchUpdatedBy.toLowerCase() === 'na') {
          filterArray.push('address eq null');
        } else {
          filterArray.push(`contains(tolower(address),tolower('${searchUpdatedBy}'))`);
        }
      }
      if (searchUpdatedDateTime) {
        if (searchUpdatedDateTime.toLowerCase() === 'na') {
          filterArray.push('active eq null');
        } else {
          filterArray.push(`active eq ${searchUpdatedDateTime}`);
        }
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }
    return requests.getWithToken(url, access_token);
  },
  appVersionCreate: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/appversion/create`, data, access_token)
  },
  appVersionEdit: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/appversion/update`, data, access_token)
  },
};

const ReturnReason = {
  getReturnReasonList: (access_token, currentPage = 1, pageSize = 10, searchReason, searchIsActive, searchCreatedBy, searchCreatedTimeStamp, sortDirection, sortOrder) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/ReturnReasonList?$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += `&$orderby=createdTimeStamp desc`
    }
    if (searchReason || searchIsActive || searchCreatedBy || searchCreatedTimeStamp) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchReason) {
        if (searchReason.toLowerCase() === 'na') {
          filterArray.push('reason eq null');
        } else {
          filterArray.push(`contains(tolower(reason),tolower('${searchReason}'))`);
        }
      }
      if (searchIsActive) {
        if (searchIsActive.toLowerCase() === 'na') {
          filterArray.push('isActive eq null');
        } else {
          filterArray.push(`isActive eq ${searchIsActive}`);
        }
      }
      if (searchCreatedBy) {
        if (searchCreatedBy.toLowerCase() === 'na') {
          filterArray.push('createdBy eq null');
        } else {
          filterArray.push(`createdBy eq ${searchCreatedBy}`);
        }
      }
      if (searchCreatedTimeStamp) {
        if (searchCreatedTimeStamp.toLowerCase() === 'na') {
          filterArray.push('createdTimeStamp eq null');
        } else {
          filterArray.push(`contains(tolower(createdTimeStamp),tolower('${searchCreatedTimeStamp}'))`);
        }
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }
    return requests.getWithToken(url, access_token);
  },
  create: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/device/add/returnreason`, data, access_token)
  },
  update: (access_token, data) => {
    return requests.postWithToken(`${apiUrl}/api/device/add/returnreason`, data, access_token)
  },
  getAssignableProducts: (access_token, searchValue) => {
    return requests.getWithToken(`${apiUrl}/api/product/assignable?key=${searchValue}`, access_token);
  },
};

const Approval = {
  getApprovalsCount: (access_token) => {
    return requests.getWithToken(`${apiUrl}/odata/approvalList?$count=true&$filter=status eq 'pending'`, access_token);
  },
  getApprovals: (access_token, currentPage = 1, pageSize = 10, searchStatus, sortDirection, sortOrder) => {
    currentPage = parseInt(currentPage, 10);
    if (Number.isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }
    let url = `${apiUrl}/odata/approvalList?$count=true&$skip=${(currentPage - 1) * pageSize}&$top=${pageSize}`;
    if (sortDirection && sortOrder) {
      url += `&$orderby=${sortOrder} ${sortDirection}`;
    }
    else {
      url += `&$orderby=requestedDateTime desc`
    }
    if (searchStatus) {
      url += `&$filter=`;
      const filterArray = [];
      if (searchStatus) {
        if (searchStatus.toLowerCase() === 'na') {
          filterArray.push('status eq null');
        } else {
          filterArray.push(`contains(tolower(status),tolower('${searchStatus}'))`);
        }
      }
      let searchTerm = "";
      if (filterArray.length > 0) {
        searchTerm = filterArray.join(' and ');
      }
      if (searchTerm.length > 0)
        url += `${searchTerm}`;
    }
    return requests.getWithToken(url, access_token);
  },
  submitApproval: (access_token, approvalObject) => {
    return requests.postWithToken(`${apiUrl}/api/user/submit`, approvalObject, access_token);
  },
};

export default {
  Auth,
  User,
  Zone,
  Organisation,
  Device,
  ReturnRequests,
  ReturnApproval,
  Product,
  Request,
  Approval,
  Dashboard,
  AppVersion,
  ReturnReason,
};
